import React from "react";
import { Routes, Route } from "react-router-dom";
import SettingsLayout from "./components/SettingsLayout";

const SettingsModule = () => {
  return (
    <Routes>
      <Route path="/*" element={<SettingsLayout />} />
    </Routes>
  );
};

export default SettingsModule;
